export const GET_EDITPOLICY_RES   		= 'GET_EDITPOLICY_RES';
export const GET_EDITPOLICY_OPT   		= 'GET_EDITPOLICY_OPT';
export const GET_SEATCHART_DETAIL 		= 'GET_SEATCHART_DETAIL';
export const GET_SEARCH_RES       		= 'GET_SEARCH_RES';
export const GET_CHECKBOX_RES     		= 'GET_CHECKBOX_RES';
export const GET_PREPOST_CHECKBOX_RES   = 'GET_PREPOST_CHECKBOX_RES';
export const UPDATE_ROUTE_INFO    		= 'UPDATE_ROUTE_INFO';
export const TOGGLE_FINAL_SAVE	  		=  'TOGGLE_FINAL_SAVE';
export const SAVE_EDIT_DETAILS	  		=  'SAVE_EDIT_DETAILS';
export const GET_OLD_SEAT	  	  		=  'GET_OLD_SEAT';
export const UPDATE_SEAT_CHART = 'UPDATE_SEAT_CHART';
export const UPDATE_SEAT_CHART_DET = 'UPDATE_SEAT_CHART_DET';
export const UPDATE_CHECKOUT_DET = 'UPDATE_CHECKOUT_DET';
export const UPDATE_HEADER_TEXT = 'UPDATE_HEADER_TEXT';
export const UPDATE_FILTER_RESET = 'UPDATE_FILTER_RESET';
export const UPDATE_USER_GENDER = 'UPDATE_USER_GENDER';
export const GET_RESCHEDULE_CHARGES = 'GET_RESCHEDULE_CHARGES';
export const GET_EDITPOLICY_DATA = 'GET_EDITPOLICY_DATA';
export const SET_NEW_DEPART_DATE = 'SET_NEW_DEPART_DATE';


// WEBPACK FOOTER //
// ./src/actions/action-types.js